import * as React from "react";
import MyPackagesMaintenancePage from "./components/MyPackagesMaintenancePage/MyPackagesMaintenancePage";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { IRepertoireField } from "../types/IRepertoireField";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { placeholder } from "lodash/fp";
import { SearchRequests } from "../services/SearchRequests";
import { MY_PACKAGE_MAINTENANCE_GROUP, MY_PACKAGE_MAINTENANCE_KEY } from "../ConfigurationConsts";
import { IMyPackagesDownloadFileFormat } from "../types/IMyPackagesDownloadFileFormat";
import { IMyPackagesDetails } from "../types/IMyPackagesDetails";
import { IRepertoirePathInfo } from "../types/IRepertoirePathInfo";
import { IComponentDataItem } from "../../core/types/IComponentDataItem";
import { IFileSystem } from "../../dataingestion/types/IFileSystem";
import { IStoragePathItemData } from "../../dataingestion/types/IStoragePathItemData";
import { ILookupInstance } from "../../lookup/types/ILookup";
import { setInDropZone, addFileToUpload, sortColumn, setProgressUploadFileProccess, CleanUploadFilesState } from "../../redux/reducers/DataIngestionReducer";
import { enableCustomField } from "../../redux/reducers/RepertoireReducer";
import { FormatFields } from "../../redux/types/FormatFields";
import IDroppedFiles from "../../redux/types/IDroppedFiles";
import { ITreeNodeData } from "../../treeview/types/TreeNodeData";
import { ITreeData } from "../types/ITreeData";
import { IDistribution } from "../types/usageTypes/IDistribution";
import { IAttachedFile } from "../../redux/types/IAttachedFile";
import { DataSource } from "../types/DataSource";
import { MATCHING_ENGINE } from "../../accounts/Consts";
import { CURRENT_USER_EMAIL_KEY } from "../../redux/services/AccountSessionStorage";


export interface IMyPackagesPageProps {
    myPackagesGridView:IRepertoireComponentDataItem;
    packageMaintenanceGridsViewData: IRepertoireComponentDataItem;
    myPackagesGeneralDataViewData:IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    editableFieldsDataView?: IRepertoireComponentDataItem;
    lookupValues: ILookupDictionary;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    editableFields: IRepertoireField[];
    incrementTempID?: () => void;
    updatedScroll?: number;
    customer?:string;
    title:string;
    placeholder:string;
    downloadFileFormat?:IMyPackagesDownloadFileFormat;
    getDownloadFileFormat?:()=>void;   
    getMyPackagesDetails?: (userName: string, modalOpen: boolean) => void;
    currentUser?:string;
    myPackagesResult?:IMyPackagesDetails[];
    getUserCRMValues?:()=>void;
    clearPackages?:(myPackages:IMyPackagesDetails)=>void;
    loadRepertoireFromPath: (pathInfo: IRepertoirePathInfo, location: Location) => void;
    generatePackage?: (myPackage: IMyPackagesDetails) => void;
    closePackage?: (myPackage: IMyPackagesDetails) => void;
    addPackageNote?: (myPackage: IMyPackagesDetails) => void;
    portalType: string;
    alertMessage: string;
    formatFields: FormatFields[];
    getFieldFormats: (key: string, group: string) => void;
    containerDetailsWindowComponentData: IComponentDataItem;
    distributions: IDistribution[];
    formats: ILookupInstance[];
    destinations: ILookupInstance[];
    selectedFileSystem: IFileSystem;
    droppedFiles: IDroppedFiles;
    setInDropZone: typeof setInDropZone;
    addFileToUpload: typeof addFileToUpload;
    sortColumn: typeof sortColumn;
    isDropZone: boolean;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    storagePaths: IStoragePathItemData[];
    storagePathItemData: IComponentDataItem;
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    customFields: number[];
    enableCustomField: typeof enableCustomField;
    getFilesystems: (isRepertoireModule?: boolean) => void;
    filesystems: IFileSystem[];
    treeNodes: ITreeNodeData<IFileSystem>[];
    selectedNode: ITreeNodeData<IFileSystem>;
    selectedNodeChanged: (node: ITreeNodeData<IFileSystem>, sources: ITreeData[]) => void;
    getDataIngestionComponentData: () => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    removeAttachmentIfExists?: (attachedFile: IAttachedFile, source: DataSource) => void;
    filesDropped?: IDroppedFiles;
    isPackageSaved?: boolean;
    packageDetails?: IMyPackagesDetails;
    fullCataloguePackagePending?: boolean;
    packageOperationInProgress?: boolean;
}

interface IMyPackagesPageState {
    toolbarWidth: number;
    ipBaseNumber: string;
    activeHeaderSection?: string;
    title?:string;
    placeholder?:string;
    myPackagesGeneralDataViewData?:IRepertoireComponentDataItem;
    currentUser?:string;
}
export type IInterestedPartyMaintenanceToolbarKeys = keyof IMyPackagesPageProps;

export class MyPackagesPage extends React.PureComponent<IMyPackagesPageProps,IMyPackagesPageState> {
    toolbarParentRef;
    constructor(props: IMyPackagesPageProps) {
        super(props)
        this.state = {
            toolbarWidth: null,
            ipBaseNumber: "",
            currentUser:""
        };
        this.toolbarParentRef = React.createRef();
    }

    componentDidMount() {
        const {
            myPackagesGeneralDataViewData: { fields },getUserCRMValues,getDownloadFileFormat,getMyPackagesDetails,myPackagesGridView,loadRepertoireFromPath,containerDetailsWindowComponentData,getDataIngestionComponentData
        } = this.props  
        const{ currentUser }=this.state
        
        const username = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY);
         if (this.props.portalType === MATCHING_ENGINE) {
            if (!containerDetailsWindowComponentData || !containerDetailsWindowComponentData.fields || containerDetailsWindowComponentData.fields.length === 0) {
                getDataIngestionComponentData();
            }
        }   
        getUserCRMValues(); 
        getDownloadFileFormat();
        getMyPackagesDetails(username,true);
    };


    render() {
        const {
            packageMaintenanceGridsViewData,
            tabs,
            activeTab,
            incrementTempID,
            customer,
            title,
            myPackagesGeneralDataViewData,
            placeholder,
            downloadFileFormat,
            getMyPackagesDetails,
            myPackagesGridView,
            myPackagesResult,
            getDownloadFileFormat,
            clearPackages,
            generatePackage,
            closePackage,
            addPackageNote,
            portalType,
            alertMessage,
            containerDetailsWindowComponentData,
            storagePathItemData,
            destinations,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            treeNodes,
            getDataIngestionComponentData,
            cleanUploadFilesState,
            setInDropZone,
            setProgressUploadFileProccess,
            addRepertoireAttachmentToState,
            addFileToUpload,
            removeAttachmentIfExists,
            filesDropped,
            isPackageSaved,
            packageDetails,
            fullCataloguePackagePending,
            packageOperationInProgress
        } = this.props;

            const username = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY);
        return (
            <>
            <a target="_blank" id="downloadLinkPackages"></a>
            <div>
              {myPackagesGeneralDataViewData && myPackagesGeneralDataViewData.fields.length > 0 && 
                <MyPackagesMaintenancePage
                        myPackagesGridView={myPackagesGridView}
                        currentUser={username}
                        myPackagesResult={myPackagesResult}
                        getMyPackagesDetails={getMyPackagesDetails}
                        getDownloadFileFormat={getDownloadFileFormat}
                        clearPackages={clearPackages}
                        packageMaintenanceGridsViewData={packageMaintenanceGridsViewData}
                        myPackagesGeneralDataViewData={myPackagesGeneralDataViewData}
                        activeTab={activeTab}
                        tabs={tabs}
                        componentInstance={null}
                        title={title}
                        isReadonly={true}
                        downloadFileFormat={downloadFileFormat}
                        activeHeaderSection={null} lookupValues={undefined}
                        generatePackage={generatePackage}
                        closePackage={closePackage}
                        addPackageNote={addPackageNote}
                        portalType={portalType}
                        alertMessage={alertMessage}
                        containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                        storagePathItemData={storagePathItemData}
                        destinations={destinations}
                        droppedFiles={droppedFiles}
                        isDropZone={isDropZone}
                        selectedFileSystem={selectedFileSystem}
                        treeNodes={treeNodes}
                        isPackageSaved={isPackageSaved}
                        packageDetails={packageDetails}
                        getDataIngestionComponentData={getDataIngestionComponentData}
                        cleanUploadFilesState={cleanUploadFilesState} 
                        addFileToUpload={addFileToUpload}  
                        setInDropZone= {setInDropZone} 
                        setProgressUploadFileProccess={setProgressUploadFileProccess}  
                        addRepertoireAttachmentToState={addRepertoireAttachmentToState} 
                        removeAttachmentIfExists={removeAttachmentIfExists}
                        fullCataloguePackagePending={fullCataloguePackagePending}
                        packageOperationInProgress={packageOperationInProgress}             />
              }
                </div>
                </>
        )
    }
}
export default MyPackagesPage;
